import React, { useState, useRef, forwardRef, useEffect } from "react";
import {
  TextField,
  Typography,
  Paper,
  Grid,
  FormControl,
  FormHelperText,
  Radio,
  RadioGroup,
  FormControlLabel,
  Checkbox,
  Box,
  Button
} from "@material-ui/core";
import useStyles from "../../styles/deviceTaskStyle";
import SelectDate from "../device/SelectDate";
import SelectMode from "./SelectMode";
import { CommandTextField, EnableTextfield } from "../commons/Textfields";
import { useTranslation } from "../../langs/useTranslation";
import { Formik, Form } from "formik";
import CommandConfirmDialog from "../commons/CommandConfirmDialog";
import SendRoundedIcon from "@material-ui/icons/SendRounded";
import * as localforage from "localforage";
import { kioskModeAPI } from "../../apis/deviceControlApi";
import { StyledSubmitBtn, BackBtn } from "../commons/FormBtns";
import {
  handleClose,
  handleHasResponseStatus
} from "../../helpers/commandConfirmationDialogAction";
import { kioskModeValuesSchema2 } from "../../config/singleDeviceTaskValuesSchema";
import { DateTimeComparisonText } from "../commons/ValidationText";
import { useParams } from "react-router-dom";
import { getDeviceTwinsApi } from "@/apis/deviceDetailAPI";
import { getTwinsDesiredOrReportedByLastUpdated } from "@/helpers/utils";
import { useDebounceFn } from "ahooks";
import { ReactRender } from "@/components/ReactRender";
import DataTable from "@/components/DataTable";
import UploadAndroidAppDialog from "@/containers/AndroidApp/UploadAndroidAppDialog"
import AddAppModal from "@/containers/ProfileConfig/CreateTemplate/AndroidConfig/AppConfig/AddAppModal";

const PackageIdEditText = ({
  value,
  onChange,
  readOnly,
  rowNumber,
  lastFoused
}) => {
  const { run: handleChange } = useDebounceFn(
    (value, type, index) => {
      onChange(old => {
        const newData = [...old]
        newData[index][type] = value
        return newData
      })
    },
    { wait: 800 }
  );
  // const [packageId, setPackageid] = useState("")

  if (readOnly) {
    return <>{value}</>;
  }

  return (
    <TextField
      size="small"
      variant="outlined"
      defaultValue={value}
      autoFocus={rowNumber === lastFoused.current}
      onFocus={() => {
        lastFoused.current = rowNumber;
      }}
      onChange={e => {
        // handleChange(e.target.value, "package_id", rowNumber);
      }}
      onKeyDown={e => {
        if (e.key === "Enter") {
          const value = e.target.value
          onChange(old => {
            const newData = [...old]
            newData[rowNumber]["package_id"] = value
            return newData
          })
        }
      }}
      style={{ width: 300 }}
    />
  );
};

const KioskModeSingleForm = forwardRef((props, ref) => {
  const classes = useStyles();
  const { device_os_type } = useParams();
  const {
    executeType,
    devices,
    deviceId,
    storedDatePickerValueToLocalforageName,
    resetAllStoredValueInLocalforage,
    successfulText,
    dispatch
  } = props;
  const { t } = useTranslation("task");
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState({});
  const [datetime, setDatetime] = useState(true);
  const [isExecuting, setIsExecuting] = useState(false);
  const [mode, setMode] = useState(1);
  const [addAppOpen, setAddAppOpen] = useState(false);
  const [apps, setApps] = useState([])
  const [forceInstall, setForceInstall] = useState(false)
  const [error, setError] = useState("");
  const [uploadOpen, setUploadOpen] = useState(false)
  const lastFoused = useRef(null);
  const formRef = useRef();

  const kioskModeInitialValues = {
    date: "",
    mode: "",
    command: "",
    enableApplication: ""
  };

  const columns = [
    {
      data: "package_id",
      title: t({ defaultMessage: "应用程序ID" }),
      orderable: false,
      createdCell: (td, data, row, rowNumber) => {
        ReactRender(
          <>
            {!data ? (
              <PackageIdEditText
                lastFoused={lastFoused}
                value={row.package_id}
                onChange={setApps}
                // readOnly={readOnly}
                rowNumber={rowNumber}
              />
            ) : (
              data
            )}
          </>,
          td
        );
      }
    },
    {
      data: "version",
      title: t({ defaultMessage: "版本" }),
      orderable: false
    },
    {
      data: null,
      title: t({ defaultMessage: "操作" }),
      className: "center nowrap",
      searchable: false,
      orderable: false,
      width: 80,
      createdCell: (td, data, row, rowNumber) => {
        ReactRender(
          <Button
            size="small"
            color="primary"
            // disabled={readOnly}
            onClick={() => {
              lastFoused.current = null;
              setApps(apps => {
                return apps.filter(
                  (app, i) => i !== rowNumber
                )
              });
            }}
          >
            {t({ defaultMessage: "移除" })}
          </Button>,
          td
        );
      }
    }
  ]

  const handleAddByPackageId = () => {
    lastFoused.current = null;
    setApps(apps => {
      return [...apps, {
        "package_id": "",
        "version": ""
      }]
    })
  }

  const handleExecuteAction = async () => {
    setIsExecuting(true);
    // Execute the task after modal opened and the confirm button clicked
    //const command = values.command;
    const enableApplication = values.enableApplication;
    const enableKioskMode = values.mode === "on" ? true : false;
    const selectedIds = [];
    const company_id = await localforage.getItem("companyId");
    const responseStatus = await kioskModeAPI(
      "company",
      company_id,
      [deviceId],
      undefined, //group_id
      undefined, //tagId
      executeType,
      enableKioskMode,
      // device_os_type === "android" && enableApplication, //enableApplicationAndroid
      device_os_type === "android" && apps && apps.length ? apps[0].package_id : "", //enableApplicationAndroid
      device_os_type === "windows" && enableApplication, //enableApplicationWindows
      device_os_type === "windows", //checkedWindows
      device_os_type === "android", //checkedAndroid
      datetime,
      null,
      undefined, //command
      t,
      successfulText,
      !enableKioskMode, //kioskModeSwitchOff
      device_os_type,
      device_os_type === "android" ? {
        mode,
        applications: apps,
        force_reinstall: forceInstall,
        enable_application_android: true
      } : {}
    );
    if (responseStatus) {
      handleHasResponseStatus(setOpen, resetAllStoredValueInLocalforage);
      setIsExecuting(false);
    }
    dispatch({ type: "stopLoading" });
  };

  useEffect(() => {
    getDeviceTwinsApi(deviceId).then(({ data }) => {
      const reported = data.properties.reported
      let v = getTwinsDesiredOrReportedByLastUpdated(data.properties, 'kiosk_mode')
      if (v === "close" || v === 0) v = "off"
      if (v === "open" || v === 1) v = "on"
      if (v === undefined) v = ""
      if (formRef.current) {
        formRef.current.setFieldValue(
          "mode",
          // reported.kiosk_mode === undefined? "": reported.kiosk_mode === 1? "on": "off"
          v
        )
      }
    })
  }, [])

  return (
    <>
      <Formik
        innerRef={formRef}
        initialValues={kioskModeInitialValues}
        validationSchema={kioskModeValuesSchema2(device_os_type)}
        onSubmit={async values => {
          if (values.mode === 'on' && device_os_type === "android" && apps.length === 0) {
            setError(t({ defaultMessage: "必须添加一个应用" }));
            return
          }
          dispatch({ type: "showLoading" });
          setValues(values);
          const datetime =
            values.date === "immediately"
              ? "immediately"
              : await localforage.getItem(storedDatePickerValueToLocalforageName);
          setDatetime(datetime);
          if (datetime) {
            setOpen(true);
          } else {
            dispatch({ type: "stopLoading" });
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <FormControl fullWidth={true} ref={ref}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Paper elevation={0} className={classes.fullWidthPaper}>
                      <Typography variant="h6">
                        {t("task.step")}1. {t("task.selectDate")}
                      </Typography>
                      <SelectDate
                        storedDatePickerValueToLocalforageName={
                          storedDatePickerValueToLocalforageName
                        }
                        formikName="date"
                        formikOnChange={handleChange}
                        formikValue={values.date}
                        formikError={errors.date && touched.date && errors.date}
                      />
                      {!datetime ? <DateTimeComparisonText /> : ""}
                    </Paper>
                    <Paper elevation={0} className={classes.fullWidthPaper}>
                      <Typography variant="h6">
                        {t("task.step")}2. {t("task.kioskModeSwitch")}
                      </Typography>
                      <SelectMode
                        formikName="mode"
                        formikOnChange={handleChange}
                        formikValue={values.mode}
                        formikError={errors.mode && touched.mode && errors.mode}
                      />
                    </Paper>
                    {/* <Paper elevation={0} className={classes.fullWidthPaper}>
                  <CommandTextField
                    CommandTextFieldPlaceHolder="e.g. -shut down 'xxxx.exe"
                    formikName="command"
                    formikOnChange={handleChange}
                    formikOnBlur={handleBlur}
                    formikValue={values.command}
                  />
                </Paper> */}
                    {values.mode === "on" && device_os_type === 'windows' && (
                      <Paper elevation={0} className={classes.fullWidthPaper}>
                        <EnableTextfield
                          CommandTextFieldPlaceHolder={
                            device_os_type === "android"
                              ? t("task.setByPackageName")
                              : t("task.setByPath")
                          }
                          formikName="enableApplication"
                          formikOnChange={handleChange}
                          formikOnBlur={handleBlur}
                          formikValue={values.enableApplication}
                        />
                        {errors.enableApplication && touched.enableApplication && (
                          <FormHelperText error>{errors.enableApplication}</FormHelperText>
                        )}
                      </Paper>
                    )}
                    {values.mode === "on" && device_os_type === 'android' && (
                      <Paper elevation={0} className={classes.fullWidthPaper}>
                        <div className="deviceControlDialogBlock">
                          <Typography variant="h6">
                            {t("task.step")}3. {t({ defaultMessage: "Kiosk 模式选择" })}
                          </Typography>
                          <FormControl component="div" fullWidth={true}>
                            <RadioGroup
                              aria-label="date"
                              value={mode}
                              onChange={e => setMode(Number(e.target.value))}
                            >
                              <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                  <FormControl>
                                    <FormControlLabel
                                      value={1}
                                      label={`${t({ defaultMessage: "单应用模式" })}`}
                                      control={<Radio color="primary" />}
                                    />
                                  </FormControl>
                                </Grid>
                                {/* <Grid item xs={12} sm={12} md={6} lg={6}>
            <FormControl>
              <FormControlLabel
                value={2}
                label={`${t({defaultMessage: "多应用模式"})}`}
                control={<Radio color="primary" />}
              />
            </FormControl>
          </Grid> */}
                              </Grid>
                            </RadioGroup>
                          </FormControl>
                          <Box marginTop={3} marginBottom={3}>
                            <Button
                              variant="outlined"
                              color="primary"
                              style={{ minWidth: 118 }}
                              onClick={() => setAddAppOpen(true)}
                              disabled={apps.length}
                            >
                              {t({ defaultMessage: "添加应用" })}
                            </Button>
                            <Button
                              variant="outlined"
                              color="primary"
                              style={{ minWidth: 118, marginLeft: 16 }}
                              onClick={handleAddByPackageId}
                              disabled={apps.length}
                            >
                              {t({ defaultMessage: "手动新增应用程序" })}
                            </Button>
                            <Button
                              variant="outlined"
                              color="primary"
                              style={{ minWidth: 118, marginLeft: 16 }}
                              onClick={() => setUploadOpen(true)}
                              disabled={apps.length}
                            >
                              {t({ defaultMessage: "本地档案上传" })}
                            </Button>
                          </Box>
                          <DataTable
                            options={{ serverSide: false }}
                            data={apps}
                            columns={columns}
                            paging={false}
                            showCheckAll={false}
                            showFooter={false}
                            autoLoad
                          />
                          <FormControlLabel
                            control={(
                              <Checkbox
                                checked={forceInstall}
                                onChange={e => setForceInstall(e.target.checked)}
                                name={t({ defaultMessage: "若设备已存在app，移除原本版本重新安装" })}
                              />
                            )}
                            label={t({ defaultMessage: "若设备已存在app，移除原本版本重新安装" })}
                          />
                          {error && <FormHelperText error>{error}</FormHelperText>}
                        </div>
                      </Paper>
                    )}

                    <div className="submit-back-btn-wrap">
                      <StyledSubmitBtn
                        startIcon={<SendRoundedIcon />}
                        btnText={t("btn.confirmBtn")}
                        btnColor="primary"
                        onClick={() => {
                          handleSubmit()
                        }}
                        type="submit"
                      />
                      <BackBtn />
                      <CommandConfirmDialog
                        isExecuting={isExecuting}
                        okBtnOnClick={handleExecuteAction}
                        backBtnOnClick={() =>
                          handleClose(setOpen, dispatch, setIsExecuting)
                        }
                        open={open}
                        dialogTitle={t("task.kioskModeName")}
                        dialogContent={t("modal.kioskModeDescription")}
                      />
                    </div>
                  </Grid>
                </Grid>
              </FormControl>
            </Form>
          )
        }}
      </Formik>
      <UploadAndroidAppDialog
        open={uploadOpen}
        onClose={() => setUploadOpen(false)}
        onSuccess={(data) => {
          setApps(apps => {
            return [...apps,
              {
                id: "",
                name: data.name,
                version: data.version,
                update_at: "",
                size: data.size,
                file_path: data.file_path,
                md5: data.md5,
                package_id: data.package_id,
                version_code: data.version_code,
              }
            ]
          })
        }}
      />
      {addAppOpen && (
        <AddAppModal
          single
          open={addAppOpen}
          onClose={() => setAddAppOpen(false)}
          enableSubVersion={false}
          // checked={checked}
          onConfirm={result => {
            setApps(apps => {
              return result.map(data => ({
                id: data.id,
                name: data.name,
                version: data.version,
                update_at: data.update_at,
                size: data.size,
                file_path: data.file_path,
                md5: data.md5,
                package_id: data.package_id,
                version_code: data.version_code,
              }))
            })
            setAddAppOpen(false);
          }}
        />
      )}
    </>
  );
});

export default KioskModeSingleForm;
